import { render, staticRenderFns } from "./complain_edit.vue?vue&type=template&id=7ad8ceca&scoped=true&"
import script from "./complain_edit.vue?vue&type=script&lang=js&"
export * from "./complain_edit.vue?vue&type=script&lang=js&"
import style0 from "./complain_edit.vue?vue&type=style&index=0&id=7ad8ceca&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ad8ceca",
  null
  
)

export default component.exports